// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.business_card_container {
    width: 85mm; /* Largeur fixe */
    height: 55mm; /* Hauteur fixe */
    perspective: 1000px;
    cursor: pointer;
  }
  
  .business_card {
    width: 100%;
    height: 100%;
    border-radius: 5px; /* Coins arrondis pour un look professionnel */
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    font-family: "Roboto", sans-serif;
    position: relative;
    transform-style: preserve-3d;
    transition: transform 0.6s ease;
  }
  
  .front {
    background: linear-gradient(135deg, #ffffff, #f5f5f5);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 8px;
  }
  
  .back {
    background: linear-gradient(135deg, #ffffff, #f5f5f5);
    color: rgb(16, 8, 8);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 8px;
    transform: rotateY(0deg);
  }
  
  .business_header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
  }
  
  .business_logo_image {
    height: 10mm; /* Taille proportionnelle au format de la carte */
    width: 10mm;
    object-fit: contain;
  }
  
  .business_company_name {
    font-size: 30px;
    font-weight: bold;
    color: #333;
  }
  
  .business_footer {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  
  .business_role {
    font-size: 10px;
    color: #555;
    font-weight: bold;
  }
  
  .business_qr_code_container {
    margin-top: 5px;
    padding: 5px;
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  
  .business_back_text {
    text-align: center;
    font-size: 12px;
    line-height: 1.4;
    margin: 0 auto;
  }
  
  .business_barcode {
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }
  `, "",{"version":3,"sources":["webpack://./src/includes/pageInside/BusinessCard.css"],"names":[],"mappings":"AAAA;IACI,WAAW,EAAE,iBAAiB;IAC9B,YAAY,EAAE,iBAAiB;IAC/B,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB,EAAE,8CAA8C;IAClE,0CAA0C;IAC1C,iCAAiC;IACjC,kBAAkB;IAClB,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,qDAAqD;IACrD,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,qDAAqD;IACrD,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;EACX;;EAEA;IACE,YAAY,EAAE,iDAAiD;IAC/D,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,gBAAgB;EAClB","sourcesContent":[".business_card_container {\n    width: 85mm; /* Largeur fixe */\n    height: 55mm; /* Hauteur fixe */\n    perspective: 1000px;\n    cursor: pointer;\n  }\n  \n  .business_card {\n    width: 100%;\n    height: 100%;\n    border-radius: 5px; /* Coins arrondis pour un look professionnel */\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n    font-family: \"Roboto\", sans-serif;\n    position: relative;\n    transform-style: preserve-3d;\n    transition: transform 0.6s ease;\n  }\n  \n  .front {\n    background: linear-gradient(135deg, #ffffff, #f5f5f5);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 8px;\n  }\n  \n  .back {\n    background: linear-gradient(135deg, #ffffff, #f5f5f5);\n    color: rgb(16, 8, 8);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 8px;\n    transform: rotateY(0deg);\n  }\n  \n  .business_header {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 10px;\n  }\n  \n  .business_logo_image {\n    height: 10mm; /* Taille proportionnelle au format de la carte */\n    width: 10mm;\n    object-fit: contain;\n  }\n  \n  .business_company_name {\n    font-size: 30px;\n    font-weight: bold;\n    color: #333;\n  }\n  \n  .business_footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n  }\n  \n  .business_role {\n    font-size: 10px;\n    color: #555;\n    font-weight: bold;\n  }\n  \n  .business_qr_code_container {\n    margin-top: 5px;\n    padding: 5px;\n    background-color: #fff;\n    border-radius: 3px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  }\n  \n  .business_back_text {\n    text-align: center;\n    font-size: 12px;\n    line-height: 1.4;\n    margin: 0 auto;\n  }\n  \n  .business_barcode {\n    display: flex;\n    justify-content: center;\n    margin-top: 10px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
